import React from 'react';
import {useTranslation} from 'react-i18next';

import {TWeekStart} from '../types';
import {getMonthDays, getMonthWeeks} from '../utils';
import {Day} from './Day';
import * as S from './style';

type TProps = {
  month: number;
  year: number;
  onSelect: (value: Date) => void;
  weekStart: TWeekStart;
  dataSelector: string;
};

export const Month = React.memo<TProps>(({month, year, weekStart, onSelect, dataSelector}) => {
  const {t} = useTranslation();

  const week = React.useMemo(() => [...Array(7)].map((_, index) => index + weekStart), [weekStart]);

  const monthWeeks = React.useMemo(
    () => getMonthWeeks(getMonthDays(year, month, weekStart)),
    [month, year, weekStart],
  );

  return (
    <S.Month data-selector={dataSelector}>
      <S.MonthRow>
        {week.map((weekDay) => (
          <S.WeekDay key={weekDay}>
            {t(`EdnaCalendar:weekdaysKeysByIndex.${weekDay === 7 ? 0 : weekDay}`)}
          </S.WeekDay>
        ))}
      </S.MonthRow>
      {monthWeeks.map((weekDay, weekIndex) => (
        <S.MonthRow key={weekIndex}>
          {weekDay.map((monthDay, dayIndex) => {
            return <Day key={dayIndex} day={monthDay} onSelect={onSelect} />;
          })}
        </S.MonthRow>
      ))}
    </S.Month>
  );
});
